export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-09.jpg'),
        title: 'CLOUD',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'THE INTEGRATION OF HARDWARE,SOFTWARE, NETWORK',
      description: `<p style="font-size:1.5rem">Cloud is the integration of hardware, software, network and other resources in WAN or LAN to realize data calculation, storage, processing and sharing. With the high development and application of the Internet industry, every item may have its own identification mark in the future, which needs to be transmitted to the back-end system for logical processing.
Different levels of data will be processed separately and various industry data need strong system backup support,
which can only be achieved through cloud computing. MaesInfo relies
on a strong software development team to provide you with
stable, reliable, secure and sustainable cloud services.</p>`
    },
    {
      title: 'Our services include:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-09.jpg')+`)"></span>
      <span class="list">
      <i></i>Mobile Interconnection<br/>
      <i></i>Sap<br/>
      <i></i>Office in Cloud<br/>
      <i></i>Upper cloud migration<br/>
      <i></i>Enterprise Cloud Disk<br/>
      <i></i>Log analysis

      </span>`
    }
  ]
}
